module.exports = __webpack_public_path__ + "img/zipper_mouth_face.c385422e.gif";